import { clientEnv } from "config"
import LogRocket from "logrocket"

function isHeadlessBrowser(): boolean {
  return (
    typeof navigator !== "undefined" &&
    (navigator.webdriver || navigator.userAgent.includes("HeadlessChrome"))
  )
}

function isLocalStorageAvailable(): boolean {
  try {
    window.localStorage
    return true
  } catch {
    return false
  }
}

if (
  clientEnv.isProduction &&
  typeof window !== "undefined" &&
  !isHeadlessBrowser() &&
  isLocalStorageAvailable()
) {
  LogRocket.init("we7skf/homeschool-boss")
}

export default LogRocket
